import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const policeMeasureForm: Form<Client> = {
  key: 'policeMeasure',
  fields: [
    {
      key: 'policeStation',
      label: 'Polizeiinspektion',
      fieldTypes: 'select',
      options: [
        {
          value: 'fuerth',
          label: 'Stadt Fürth',
        },
        {
          value: 'zirndorf',
          label: 'Zirndorf',
        },
        {
          value: 'stein',
          label: 'Stein',
        },
      ],
    },
    {
      key: 'policeMeasure',
      label: 'Polizeiliche Maßnahmen/Aktenzeichen',
      fieldTypes: 'text',
    },
  ],
};

export default policeMeasureForm;
